"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Api from "../api/api";
import "../services/api_service";
import BouncesMessage from "./bounces_message";
import DisablingButton from "./disabling_button";
import EmailTypeAhead from "./email_typeahead";
import { emailService } from "../services/email_service";
import { Flash } from "../components/flash";
import OutgoingEmailSignature from "../helpers/outgoing_email_signature";
class EmailForwarder extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      mark_complete: false,
      note: OutgoingEmailSignature.signatureWithBuffer(),
      add_as_contacts: false,
      contactEmails: [],
      recipients: []
    });
    __publicField(this, "recipientsChanged", (recipients, bounces) => {
      this.setState({
        recipients
      });
    });
    __publicField(this, "forward", () => {
      this.setState({ forwarding: true });
      Api.Email.forward({
        ids: [this.props.email.id],
        recipients: this.state.recipients.join(),
        complete: this.state.mark_complete,
        note: this.state.note,
        add_as_contacts: this.state.add_as_contacts
      }).then(
        (data) => {
          emailService.updateFromData(data);
          Flash.success("Hurray, the email is on its way!");
          this.props.onDone(this.state.mark_complete);
        },
        (error) => {
          this.setState({ forwarding: false });
          return error;
        }
      );
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "EmailForwarder",
        className: "modal__medium-container email-forwarder",
        children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "small-12 column", children: [
            /* @__PURE__ */ jsx(BouncesMessage, { recipients: this.state.recipients }),
            /* @__PURE__ */ jsx("label", { children: "Recipients" }),
            /* @__PURE__ */ jsx(
              EmailTypeAhead,
              {
                focusBehavior: "focus",
                onChange: this.recipientsChanged
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "small-12 column email-forwarder__checkboxes", children: [
            /* @__PURE__ */ jsxs("label", { children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "checkbox",
                  checked: this.state.mark_complete || false,
                  onChange: (e) => this.setState({
                    mark_complete: e.target.checked
                  })
                }
              ),
              /* @__PURE__ */ jsx("span", { children: "\xA0Ignore this invoice and remove it from the dashboard." })
            ] }),
            /* @__PURE__ */ jsxs("label", { children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "checkbox",
                  checked: this.state.add_as_contacts || false,
                  onChange: (e) => this.setState({
                    add_as_contacts: e.target.checked
                  })
                }
              ),
              /* @__PURE__ */ jsx("span", { children: "\xA0Save new email addresses as contacts" })
            ] }),
            /* @__PURE__ */ jsx("label", { children: "Note" }),
            /* @__PURE__ */ jsx(
              "textarea",
              {
                rows: 5,
                value: this.state.note || "",
                onChange: (e) => this.setState({ note: e.target.value })
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "small-12 column", children: [
            /* @__PURE__ */ jsx(
              DisablingButton,
              {
                className: "button--confirmation",
                disabled: this.state.forwarding || !Array.isArray(this.state.recipients) || this.state.recipients.length === 0,
                disabledText: this.state.forwarding ? "Forwarding..." : "Enter Recipients to Forward Email",
                onClick: this.forward,
                children: "Forward Email"
              }
            ),
            /* @__PURE__ */ jsxs("span", { className: "button--cancel-wrapper", children: [
              /* @__PURE__ */ jsx("span", { children: "or" }),
              /* @__PURE__ */ jsx("button", { onClick: this.props.onCancel, className: "button--cancel", children: "cancel" })
            ] })
          ] })
        ] })
      }
    );
  }
}
export { EmailForwarder };
